import React from 'react';
import { Box, Typography, styled } from '@mui/material';

const StepperContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  width: '100%'
}));

const StepDot = styled(Box)(({ theme, status }) => ({
  width: '40px',
  height: '6px',
  borderRadius: '3px',
  backgroundColor: 
    status === 'completed' ? theme.palette.success.main :
    status === 'in_progress' ? theme.palette.warning.main :
    theme.palette.grey[300],
  transition: 'all 0.3s ease'
}));

const ProductDetailsStepper = ({ steps }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {steps.map((product, index) => (
        <Box 
          key={product.name}
          sx={{ 
            display: 'flex',
            alignItems: 'center',
            gap: 2
          }}
        >
                     <Typography
             sx={{
               minWidth: '150px',
               color: (theme) => theme.palette.text.primary,
               fontSize: '14px',
               fontWeight: 400
             }}
           >
             {`${index + 1}. ${product.name}`}
           </Typography>
          <StepperContainer>
            {product.steps.map((status, stepIndex) => (
              <StepDot 
                key={`${product.name}-step-${stepIndex}`}
                status={status}
              />
            ))}
          </StepperContainer>
        </Box>
      ))}
    </Box>
  );
};

export default ProductDetailsStepper; 